// extracted by mini-css-extract-plugin
module.exports = {"root":"_2loD5","title":"_1PFEy","subTitle":"_2Cb-s","liveLabel":"hOMsY","errorBox":"RxYla","errorTitle":"HBI8U","errorLink":"f41A6"};